import { render } from "./AdminEventHistory.vue?vue&type=template&id=e22a3c66&scoped=true"
import script from "./AdminEventHistory.vue?vue&type=script&lang=js"
export * from "./AdminEventHistory.vue?vue&type=script&lang=js"

import "./AdminEventHistory.vue?vue&type=style&index=0&id=e22a3c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22a3c66"]])

export default __exports__